import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight, BookOpen, Globe2, ShieldCheck } from "lucide-react";
import { PageHero } from "./Universita";
import { LOGOS } from "../data/universities";

const MILESTONES = [
  { y: "1960s", t: "Nasce l'Istituto Privato Lingue d'Europa", d: "L'inizio di un percorso formativo nel centro di Sassari, dedicato alle lingue straniere." },
  { y: "1982", t: "Riconoscimento legale", d: "Istituto Tecnico Commerciale e per Geometri: una svolta nell'offerta scolastica." },
  { y: "1984", t: "Nasce il Liceo Linguistico", d: "L'Istituto amplia l'offerta con un percorso liceale orientato all'internazionalità." },
  { y: "2003", t: "Scuola Paritaria", d: "Riconoscimento ministeriale come scuola paritaria a tutti gli effetti." },
  { y: "Oggi", t: "Polo ECP – tre università telematiche", d: "Centro ECP riconosciuto per Pegaso, Mercatorum e San Raffaele: l'eccellenza della formazione online a Sassari." },
];

export default function ChiSiamo() {
  return (
    <div data-testid="page-chi-siamo">
      <PageHero
        eyebrow="Istituto Europa – Fondazione Gianni e Mario Profili"
        title="Sessant'anni di formazione a Sassari."
        sub="Una storia di passione educativa, oggi al servizio della laurea online: il Polo ECP Profili."
      />

      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="rounded-3xl overflow-hidden border border-brand-line bg-white p-12 flex items-center justify-center relative" data-testid="chi-siamo-logo">
              <div className="absolute inset-0 dot-pattern opacity-[0.08]" />
              <img src={LOGOS.europa} alt="Istituto Europa Sassari" className="relative max-h-72 object-contain" />
            </div>
          </div>
          <div className="lg:col-span-7">
            <div className="eyebrow text-brand-emerald mb-3">La nostra missione</div>
            <h2 className="font-heading font-extrabold text-3xl sm:text-4xl text-brand-navy leading-tight">
              Una sede moderna, una tradizione consolidata.
            </h2>
            <p className="mt-5 text-brand-muted text-lg leading-relaxed">
              L'Istituto Europa nasce negli anni '60 come scuola di lingue, evolve in scuola paritaria nel 2003 e diventa oggi punto di riferimento per la formazione universitaria online in Sardegna. Offriamo un ambiente accogliente, ben attrezzato e tutor presenti, per fare di ogni studente un protagonista.
            </p>

            <div className="mt-8 grid sm:grid-cols-3 gap-4">
              {[
                { i: BookOpen, t: "Recupero anni", d: "Sostegno e recupero materie scolastiche." },
                { i: Globe2, t: "Test universitari", d: "Preparazione test di ammissione." },
                { i: ShieldCheck, t: "Formazione Enti", d: "Corsi per PA, aziende e professionisti." },
              ].map((s) => {
                const Icon = s.i;
                return (
                  <div key={s.t} className="rounded-2xl bg-brand-surface border border-brand-line p-5">
                    <Icon className="w-5 h-5 text-brand-emerald mb-2" />
                    <div className="font-heading font-bold text-brand-navy">{s.t}</div>
                    <div className="text-sm text-brand-muted mt-1">{s.d}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 lg:py-24 bg-brand-surface">
        <div className="max-w-5xl mx-auto px-5 lg:px-8">
          <div className="eyebrow text-brand-emerald mb-3 text-center">La nostra storia</div>
          <h2 className="font-heading font-extrabold text-3xl sm:text-4xl text-brand-navy text-center mb-12">
            Dal 1960 a oggi
          </h2>
          <div className="space-y-6">
            {MILESTONES.map((m, i) => (
              <div key={i} className="grid grid-cols-[100px_1fr] gap-6 items-start" data-testid={`milestone-${i}`}>
                <div className="font-heading font-extrabold text-2xl text-brand-emerald text-right pt-1">{m.y}</div>
                <div className="rounded-2xl bg-white border border-brand-line p-6 lift-card">
                  <div className="flex items-center gap-2 mb-2">
                    <CheckCircle2 className="w-5 h-5 text-brand-emerald" />
                    <h3 className="font-heading font-bold text-lg text-brand-navy">{m.t}</h3>
                  </div>
                  <p className="text-brand-muted">{m.d}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-brand-navy text-white">
        <div className="max-w-4xl mx-auto px-5 lg:px-8 text-center">
          <div className="eyebrow text-brand-emerald">Direzione didattica</div>
          <p className="text-white/80 mt-4 max-w-2xl mx-auto">
            Il Polo ECP accompagna ogni studente in un percorso personalizzato di laurea online, con tutor universitari altamente qualificati in ogni fase del percorso.
          </p>
          <Link to="/contatti" className="btn-primary mt-6 inline-flex" data-testid="chi-siamo-cta">
            Contattaci <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
